import { buildServicesUrl } from "@services/routes";
import { ReactNode } from "react";
import { Link } from "react-router";

type SiteLinkProps = {
  /** The site(s) to open the services page for. */
  sites: string[];
  productionArea?: string;
  children: ReactNode;
  className?: string;
};

function SiteLink({
  sites,
  productionArea,
  children,
  className,
}: SiteLinkProps) {
  return (
    <Link to={buildServicesUrl(sites, productionArea)} className={className}>
      {children}
    </Link>
  );
}

export default SiteLink;
